var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sticker)?_c('img',{staticClass:"sticker",attrs:{"src":_vm.sticker}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }